export default __webpack_public_path__ + "static/media/fortune Daily.824cf4ed.png";